export const useStyles = (theme) => ({
  loader: {
    padding: 20,
    minHeight: "60vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
});
